export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var ff_onesprite = false;

export var to_load_json_atlas = {

};

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background' 	: imgsPath + "reels/reels_background_{q}.png",
    'reels_cover' 	: imgsPath + "reels/reels_cover_{q}.png",
    'logo_reels' 	: imgsPath + "reels/logo_reels_{q}.png",



    "symbol_BAR_boom"		:	imgsPath + "symbols/symbol_BAR_boom/symbol_BAR_boom_sprite_{q}.png",
    "symbol_bell_boom"		:	imgsPath + "symbols/symbol_bell_boom/symbol_bell_boom_sprite_{q}.png",
    "symbol_dollar_boom"	:	imgsPath + "symbols/symbol_dollar_boom/symbol_dollar_boom_sprite_{q}.png",
    "symbol_grapes_boom"	:	imgsPath + "symbols/symbol_grapes_boom/symbol_grapes_boom_sprite_{q}.png",
    "symbol_cherry_boom"	:	imgsPath + "symbols/symbol_cherry_boom/symbol_cherry_boom_sprite_{q}.png",
    "symbol_melone_boom"	:	imgsPath + "symbols/symbol_melone_boom/symbol_melone_boom_sprite_{q}.png",
    "symbol_orange_boom"	:	imgsPath + "symbols/symbol_orange_boom/symbol_orange_boom_sprite_{q}.png",
    "symbol_plum_boom"		:	imgsPath + "symbols/symbol_plum_boom/symbol_plum_boom_sprite_{q}.png",
    "symbol_star_boom"		:	imgsPath + "symbols/symbol_star_boom/symbol_star_boom_sprite_{q}.png",

    "symbol_BAR_freeze"		:	imgsPath + "symbols/symbol_BAR_freeze/symbol_BAR_freeze_sprite_{q}.png",
    "symbol_bell_freeze"		:	imgsPath + "symbols/symbol_bell_freeze/symbol_bell_freeze_sprite_{q}.png",
    "symbol_dollar_freeze"	:	imgsPath + "symbols/symbol_dollar_freeze/symbol_dollar_freeze_sprite_{q}.png",
    "symbol_grapes_freeze"	:	imgsPath + "symbols/symbol_grapes_freeze/symbol_grapes_freeze_sprite_{q}.png",
    "symbol_cherry_freeze"	:	imgsPath + "symbols/symbol_cherry_freeze/symbol_cherry_freeze_sprite_{q}.png",
    "symbol_melone_freeze"	:	imgsPath + "symbols/symbol_melone_freeze/symbol_melone_freeze_sprite_{q}.png",
    "symbol_orange_freeze"	:	imgsPath + "symbols/symbol_orange_freeze/symbol_orange_freeze_sprite_{q}.png",
    "symbol_plum_freeze"		:	imgsPath + "symbols/symbol_plum_freeze/symbol_plum_freeze_sprite_{q}.png",
    "symbol_star_freeze"		:	imgsPath + "symbols/symbol_star_freeze/symbol_star_freeze_sprite_{q}.png",

    "symbol_BAR_bell"		:	imgsPath + "symbols/symbol_BAR_bell/symbol_BAR_bell_sprite_{q}.png",
    "symbol_BAR_dollar"		:	imgsPath + "symbols/symbol_BAR_dollar/symbol_BAR_dollar_sprite_{q}.png",
    "symbol_BAR_grapes"		:	imgsPath + "symbols/symbol_BAR_grapes/symbol_BAR_grapes_sprite_{q}.png",
    "symbol_BAR_cherry"		:	imgsPath + "symbols/symbol_BAR_cherry/symbol_BAR_cherry_sprite_{q}.png",
    "symbol_BAR_melone"		:	imgsPath + "symbols/symbol_BAR_melone/symbol_BAR_melone_sprite_{q}.png",
    "symbol_BAR_orange"		:	imgsPath + "symbols/symbol_BAR_orange/symbol_BAR_orange_sprite_{q}.png",
    "symbol_BAR_plum"		:	imgsPath + "symbols/symbol_BAR_plum/symbol_BAR_plum_sprite_{q}.png",
    "symbol_BAR_star"		:	imgsPath + "symbols/symbol_BAR_star/symbol_BAR_star_sprite_{q}.png",


    "settings_background_1"		:	imgsPath + "infos/settings_background_1_{q}.png",
    "settings_background_2"		:	imgsPath + "infos/settings_background_2_{q}.png",
    "settings_background_3"		:	imgsPath + "infos/settings_background_3_{q}.png",
    "settings_background_4"		:	imgsPath + "infos/settings_background_4_{q}.png",

    "big_win" : imgsPath + "bigwin/big-win_{q}.png",
    "mega_win" : imgsPath + "bigwin/mega-win_{q}.png",
    "super_mega_win" : imgsPath + "bigwin/super-mega-win_{q}.png",


    "mystery_fadeout" : imgsPath + "mystery/mystery-fadeout_{q}.png",
    "mystery_selection" : imgsPath + "mystery/Mystery_selection_{q}.png",
    "mystery_fadeout_aplha" : imgsPath + "mystery/mystery-fadeout_aplha_{q}.png",
    "mystery_green" : imgsPath + "mystery/green_{q}.png",
    "mystery_red" : imgsPath + "mystery/red_{q}.png",
    "mystery_gold" : imgsPath + "mystery/gold_{q}.png",

    "mystery_btn_basic" : imgsPath + "mystery/btn_choose_basic_{q}.png",
    "mystery_btn_disabled" : imgsPath + "mystery/btn_choose_disabled_{q}.png",
    "mystery_btn_press" : imgsPath + "mystery/btn_choose_press_{q}.png",

    //"your_mystery_win" : imgsPath + "mystery/your_mystery_win_{l}_{q}.png",

    "middle_x2" : imgsPath + "reels/pendl-middle_x2_{q}.png",
    "middle_x3" : imgsPath + "reels/pendl-middle_x3_{q}.png",
    "middle_x4" : imgsPath + "reels/pendl-middle_x4_{q}.png",
    "middle_x5" : imgsPath + "reels/pendl-middle_x5_{q}.png",
    "middle_x6" : imgsPath + "reels/pendl-middle_x6_{q}.png",
    "middle_x8" : imgsPath + "reels/pendl-middle_x8_{q}.png",
    "middle_x16" : imgsPath + "reels/pendl-middle_x16_{q}.png",
    "middle_x32" : imgsPath + "reels/pendl-middle_x32_{q}.png",

    "sparkle" : imgsPath + "reels/sparkle_{q}.png",
};

export var freezed = [
    'symbol_BAR_bell',
    'symbol_BAR_dollar',
    'symbol_BAR_grapes',
    'symbol_BAR_cherry',
    'symbol_BAR_melone',
    'symbol_BAR_orange',
    'symbol_BAR_plum',
    'symbol_BAR_star',
    'symbol_BAR_freeze',
    'symbol_bell_freeze',
    'symbol_dollar_freeze',
    'symbol_grapes_freeze',
    'symbol_cherry_freeze',
    'symbol_melone_freeze',
    'symbol_orange_freeze',
    'symbol_plum_freeze',
    'symbol_star_freeze',
];

for(var i in freezed)
{
    to_load[freezed[i] + "_freezed"] = imgsPath + "symbols/" + freezed[i] + "/" + freezed[i] + "_freezed_{q}.png";
}

export const to_load_audio = {
    'mystery_win'		:	audioPath + 'bwin_Mystery.ogg',

    'reels'				:	audioPath + 'reel_Spin.ogg',

    'reel_rotation_3'	:	audioPath + 'reel_Start_1.ogg',
    'reel_rotation_4'	:	audioPath + 'reel_Start_2.ogg',
    'reel_rotation_5'	:	audioPath + 'reel_Start_3.ogg',

    'stop_sound'		:	audioPath + 'reel_Stop.ogg',
    'smack_ice_bar'		:	audioPath + 'reel_IceBar.ogg',
    'tetris_system'		:	audioPath + 'reel_Tetris.ogg',

    'WIN_LINE_DOL_1'	:	audioPath + 'win_Dollar_1.ogg',
    'WIN_LINE_DOL_2'	:	audioPath + 'win_Dollar_2.ogg',
    'WIN_LINE_DOL_3'	:	audioPath + 'win_Dollar_3.ogg',
    'WIN_LINE_DOL_4'	:	audioPath + 'win_Dollar_4.ogg',
    'WIN_LINE_DOL_5'	:	audioPath + 'win_Dollar_5.ogg',
    'WIN_LINE_HRO_1'	:	audioPath + 'win_Grape_1.ogg',
    'WIN_LINE_HRO_2'	:	audioPath + 'win_Grape_2.ogg',
    'WIN_LINE_HRO_3'	:	audioPath + 'win_Grape_3.ogg',
    'WIN_LINE_HRO_4'	:	audioPath + 'win_Grape_4.ogg',
    'WIN_LINE_HRO_5'	:	audioPath + 'win_Grape_5.ogg',
    'WIN_LINE_HVE_1'	:	audioPath + 'win_Star_1.ogg',
    'WIN_LINE_HVE_2'	:	audioPath + 'win_Star_2.ogg',
    'WIN_LINE_HVE_3'	:	audioPath + 'win_Star_3.ogg',
    'WIN_LINE_HVE_4'	:	audioPath + 'win_Star_4.ogg',
    'WIN_LINE_HVE_5'	:	audioPath + 'win_Star_5.ogg',
    'WIN_LINE_MEL_1'	:	audioPath + 'win_Melon_1.ogg',
    'WIN_LINE_MEL_2'	:	audioPath + 'win_Melon_2.ogg',
    'WIN_LINE_MEL_3'	:	audioPath + 'win_Melon_3.ogg',
    'WIN_LINE_MEL_4'	:	audioPath + 'win_Melon_4.ogg',
    'WIN_LINE_MEL_5'	:	audioPath + 'win_Melon_5.ogg',
    'WIN_LINE_POM_1'	:	audioPath + 'win_Orange_1.ogg',
    'WIN_LINE_POM_2'	:	audioPath + 'win_Orange_2.ogg',
    'WIN_LINE_POM_3'	:	audioPath + 'win_Orange_3.ogg',
    'WIN_LINE_POM_4'	:	audioPath + 'win_Orange_4.ogg',
    'WIN_LINE_POM_5'	:	audioPath + 'win_Orange_5.ogg',
    'WIN_LINE_SVE_1'	:	audioPath + 'win_Plum_1.ogg',
    'WIN_LINE_SVE_2'	:	audioPath + 'win_Plum_2.ogg',
    'WIN_LINE_SVE_3'	:	audioPath + 'win_Plum_3.ogg',
    'WIN_LINE_SVE_4'	:	audioPath + 'win_Plum_4.ogg',
    'WIN_LINE_SVE_5'	:	audioPath + 'win_Plum_5.ogg',
    'WIN_LINE_TRE_1'	:	audioPath + 'win_Cherry_1.ogg',
    'WIN_LINE_TRE_2'	:	audioPath + 'win_Cherry_2.ogg',
    'WIN_LINE_TRE_3'	:	audioPath + 'win_Cherry_3.ogg',
    'WIN_LINE_TRE_4'	:	audioPath + 'win_Cherry_4.ogg',
    'WIN_LINE_TRE_5'	:	audioPath + 'win_Cherry_5.ogg',
    'WIN_LINE_ZVON_1'	:	audioPath + 'win_Bell_1.ogg',
    'WIN_LINE_ZVON_2'	:	audioPath + 'win_Bell_2.ogg',
    'WIN_LINE_ZVON_3'	:	audioPath + 'win_Bell_3.ogg',
    'WIN_LINE_ZVON_4'	:	audioPath + 'win_Bell_4.ogg',
    'WIN_LINE_ZVON_5'	:	audioPath + 'win_Bell_5.ogg',
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",

    'mystery_selection'	:	audioPath + 'bg_Mystery.ogg',

    'Explosion_win'		:	audioPath + 'misc_Explosion.ogg',

    'MG_WIN'			:	audioPath + 'win_Multiplier.ogg',
    /*


    'ICEBAR_FRZ_1'		:	audioPath + 'ICEBAR_FRZ_1.ogg',
    'ICEBAR_FRZ_2'		:	audioPath + 'ICEBAR_FRZ_2.ogg',
    'ICEBAR_FRZ_3'		:	audioPath + 'ICEBAR_FRZ_3.ogg',
    'ICEBAR_FRZ_4'		:	audioPath + 'ICEBAR_FRZ_4.ogg',

    'Explosion_win3'	:	audioPath + 'Explosion_win3.ogg',
    */
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_mystery_wintable' :	{
        img:	imgsPath + 'fonts/font_mystery_wintable.png',
        xml:	imgsPath + 'fonts/font_mystery_wintable.xml',
    },
    'font_wintable' :	{
        img:	imgsPath + 'fonts/font_wintable.png',
        xml:	imgsPath + 'fonts/font_wintable.xml',
    },
    'font_mystery_win' :	{
        img:	imgsPath + 'fonts/font_mystery_win.png',
        xml:	imgsPath + 'fonts/font_mystery_win.xml',
    },
    'font_mystery' :	{
        img:	imgsPath + 'fonts/font_mystery.png',
        xml:	imgsPath + 'fonts/font_mystery.xml',
    }
};

import { madnes_set_audio_volume } from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config)
{
    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('mystery_win', server_config.volume.bigWin);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('reels', server_config.volume.spin);
    }
    if(typeof server_config.volume.startReel != "undefined")
    {
        madnes_set_audio_volume('reel_rotation_3', server_config.volume.startReel);
        madnes_set_audio_volume('reel_rotation_4', server_config.volume.startReel);
        madnes_set_audio_volume('reel_rotation_5', server_config.volume.startReel);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('stop_sound', server_config.volume.stopReel);
        madnes_set_audio_volume('tetris_system', server_config.volume.stopReel);
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('WIN_LINE_DOL_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_DOL_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_DOL_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_DOL_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_DOL_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_HRO_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HRO_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HRO_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HRO_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HRO_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_HVE_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HVE_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HVE_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HVE_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_HVE_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_MEL_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_MEL_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_MEL_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_MEL_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_MEL_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_POM_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_POM_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_POM_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_POM_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_POM_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_SVE_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SVE_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SVE_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SVE_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_SVE_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_TRE_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_TRE_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_TRE_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_TRE_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_TRE_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_ZVON_1', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_ZVON_2', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_ZVON_3', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_ZVON_4', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_ZVON_5', server_config.volume.winAnim);

        madnes_set_audio_volume('WIN_LINE_ZVON_5', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
        madnes_set_audio_volume('MG_WIN', server_config.volume.winCounter);
    }
    if(typeof server_config.background.bonusGameBackground != "undefined")
    {
        madnes_set_audio_volume('mystery_selection', server_config.background.bonusGameBackground);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }
    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('Explosion_win', server_config.miscSounds.miscSounds2);
    }
    if(typeof server_config.miscSounds.miscSounds4 != "undefined")
    {
        madnes_set_audio_volume('ICEBAR_FRZ_1', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('ICEBAR_FRZ_2', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('ICEBAR_FRZ_3', server_config.miscSounds.miscSounds4);
        madnes_set_audio_volume('ICEBAR_FRZ_4', server_config.miscSounds.miscSounds4);
    }
    if(typeof server_config.miscSounds.miscSounds5 != "undefined")
    {
        madnes_set_audio_volume('Explosion_win3', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('smack_ice_bar', server_config.volume.stopReel);
    }

    // for(var i in to_load_audio_madnes)
    // {
    //     if(typeof madnes_audio_levels[i] == "undefined")
    //     {
    //         console.log("Not set " + i);
    //     }
    // }
}